document.addEventListener('DOMContentLoaded', () => {

  // Information Banner Logic
  const infoBar = document.querySelector('.info-bar-top');
  if (infoBar) {
    // Show title after 1 second
    setTimeout(() => {
      infoBar.classList.add('show-title');
    }, 1000);
  }

  // Hero Slider Logic (Top Page)
  const sliders = document.querySelectorAll('.hero-slider');
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.hero-slide');
    if (slides.length > 1) {
      let currentSlide = 0;
      setInterval(() => {
        slides[currentSlide].classList.remove('active');
        currentSlide = (currentSlide + 1) % slides.length;
        slides[currentSlide].classList.add('active');
      }, 4000); // Change image every 4 seconds
    }
  });

  // Header Scroll Logic (Inner Pages)
  const header = document.querySelector('.header-common');
  if (header && !document.querySelector('.top-page')) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // Hamburger Menu Logic
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav-overlay');
  
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active');
      mobileNav.classList.toggle('open');
      document.body.classList.toggle('nav-open');
      
      // If on top page, toggle hamburger color
      if (document.querySelector('.top-page') || document.body.classList.contains('top-page')) {
        const spans = hamburger.querySelectorAll('span');
        if (hamburger.classList.contains('active')) {
          spans.forEach(span => span.style.setProperty('background-color', '#000000', 'important'));
        } else {
          spans.forEach(span => span.style.setProperty('background-color', '#ffffff', 'important'));
        }
      }
    });
  }

  // Mobile Accordion Logic (Online Store Navigation)
  const accordionBtns = document.querySelectorAll('.mobile-accordion-btn');
  accordionBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const parentItem = btn.closest('.mobile-store-item');
      if (parentItem) {
        parentItem.classList.toggle('is-open');
      }
    });
  });

  // Store Dropdown Click toggle (第1階層クリックで2階層ドロップダウン表示)
  const dropdownItems = document.querySelectorAll('.header-nav .store-nav-item.has-dropdown');
  dropdownItems.forEach(item => {
    const link = item.querySelector('.nav-link');
    if (link) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = item.classList.contains('is-open');
        dropdownItems.forEach(other => other.classList.remove('is-open'));
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.header-nav .store-nav-item.has-dropdown')) {
      dropdownItems.forEach(item => item.classList.remove('is-open'));
    }
  });

});

